import React from 'react'
import axios from 'axios'
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
	CardTitle,
	Button,
	Input
} from 'reactstrap'

import QuantitiesActions from '~/actions/quantities.js'

import apiUtils from '~/helper/api.js'


export default class RecipeQuantitiesModalAdd extends React.Component {
	static getDefaultState() {
		return {
			btnSubmitDisabled: true,
			quantityAbbrev: '',
			quantity: ''
		}
	}

	constructor(props) {
		super(props)

		this.state = RecipeQuantitiesModalAdd.getDefaultState()
	}

	setSubmitButtonStatus = () => {
		this.setState({
			btnSubmitDisabled: (
				this.state.quantityAbbrev === ''
				|| this.state.quantity === ''
			)
		})
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	submit = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.post(
			`${apiUtils.getApiURL()}/quantities`,
			{
				quantity: this.state.quantity,
				quantityAbbrev: this.state.quantityAbbrev,
				isActive: 1
			}
		)
			.then(
				() => {
					// clear the form
					this.setState(RecipeQuantitiesModalAdd.getDefaultState())

					// refresh the list
					QuantitiesActions.reload()
				}
			)
	}

	render() {
		const objSubmitButton = {}

		if (this.state.btnSubmitDisabled === true) {
			objSubmitButton.title = 'Enter abbreviation and quantity to enable this button'
		}


		return (
			<Card body inverse color="secondary">
				<CardTitle>
					Add New Quantity
				</CardTitle>
				<CardBody style={{ margin: 0, padding: 0 }}>
					<Container fluid style={{ margin: 0, padding: 0 }}>
						<Row className="mb-2">
							<Col xs={5}>
								Abbreviation
								&nbsp;
								<em>
									(ex: tbsp, oz)
								</em>
							</Col>
							<Col xs={7}>
								<Input
									name="quantityAbbrev"
									value={this.state.quantityAbbrev}
									onChange={this.handleChange}
									maxLength={8}
								/>
							</Col>
						</Row>
						<Row>
							<Col xs={5}>
								Entire Word
								&nbsp;
								<em>
									(ex: tablespoons, ounces)
								</em>
							</Col>
							<Col xs={7}>
								<Input
									name="quantity"
									value={this.state.quantity}
									onChange={this.handleChange}
									maxLength={32}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								&nbsp;
							</Col>
						</Row>
						<Row>
							<Col xs={5} />
							<Col xs={7}>
								<Button
									onClick={this.submit}
									color="success"
									disabled={this.state.btnSubmitDisabled}
									block
									{...objSubmitButton}
								>
									Add New Quantity
								</Button>
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities/add.jsx